var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/HierarchyEnums';
let HierarchyModule = class HierarchyModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.hierarchyList = [];
        this.hierarchyId = [];
        this.hierarchyDesc = [];
        this.isActive = true;
        this.useFilter = true;
        this.hierarchyPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.desc = '';
        this.searchBy = '';
        this.status = '';
        this.statusMessage = '';
        this.active = true;
        this.mainCategoryId = [];
        this.assetCategoryId = [];
        this.groupId = [];
        this.assetProfillingClassId = [];
        this.assetProfillingId = [];
        this.mainCategoryDesc = [];
        this.assetCategoryDesc = [];
        this.groupDesc = [];
        this.assetProfillingClassDesc = [];
        this.assetProfillingDesc = [];
        this.selectedHierarchyProfillingId = [];
        this.selectedHierarchyProfillingDesc = [];
        this.selectedFilterMainCategoryDesc = [];
        this.selectedFilterAssetCategoryDesc = [];
        this.selectedFilterGroupDesc = [];
        this.selectedFilterAssetProfClassDesc = [];
        this.selectedFilterAssetProfDesc = [];
        this.pageDefault = 1;
        this.filterHierarchyMainCategory = [];
        this.filterHierarchyAssetCategory = [];
        this.filterHierarchyGroup = [];
        this.filterHierarchyAssetProfClass = [];
        this.filterHierarchyAssetProf = [];
        this.resetHierarchy = true;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.pageFilterMainCategory = 1;
        this.descFilterMainCategory = '';
        this.searchByFilterMainCategory = '';
        this.wasLoadQuickFilterMainCategory = true;
        this.pageFilterAssetCategory = 1;
        this.descFilterAssetCategory = '';
        this.searchByFilterAssetCategory = '';
        this.wasLoadQuickFilterAssetCategory = true;
        this.pageFilterGroup = 1;
        this.descFilterGroup = '';
        this.searchByFilterGroup = '';
        this.wasLoadQuickFilterGroup = true;
        this.pageFilterAssetProfillingClass = 1;
        this.wasLoadQuickFilterAssetProfillingClass = true;
        this.descFilterAssetProfillingClass = '';
        this.searchByFilterAssetProfillingClass = '';
        this.pageFilterAssetProfilling = 1;
        this.wasLoadQuickFilterAssetProfilling = true;
        this.descFilterAssetProfilling = '';
        this.searchByFilterAssetProfilling = '';
        this.dataFindHierarchyMainCategory = null;
        this.dataFindHierarchyAssetCategory = null;
        this.dataFindHierarchyGroup = null;
        this.dataFindHierarchyAssetProfillingClass = null;
        this.dataFindHierarchyAssetProfilling = null;
    }
    get getHierarchyWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getResetHierarchy() {
        return this.resetHierarchy;
    }
    get getSelectedHierarchyProfillingId() {
        return this.selectedHierarchyProfillingId;
    }
    get getSelectedHierarchyProfillingDesc() {
        return this.selectedHierarchyProfillingDesc;
    }
    get getSelectedFilterMainCategoryDesc() {
        return this.selectedFilterMainCategoryDesc;
    }
    get getSelectedFilterAssetCategoryDesc() {
        return this.selectedFilterAssetCategoryDesc;
    }
    get getSelectedFilterGroupDesc() {
        return this.selectedFilterGroupDesc;
    }
    get getSelectedFilterAssetProfClassDesc() {
        return this.selectedFilterAssetProfClassDesc;
    }
    get getSelectedFilterAssetProfDesc() {
        return this.selectedFilterAssetProfDesc;
    }
    get getUseFilterHierarchy() {
        return this.useFilter;
    }
    get getHierarchyStatusActivation() {
        return this.isActive;
    }
    get getHierarchyLoading() {
        return this.loading;
    }
    get getHierarchyLists() {
        return this.hierarchyList;
    }
    get getHierarchyListId() {
        return this.hierarchyId;
    }
    get getHierarchyListDesc() {
        return this.hierarchyDesc;
    }
    get getHierarchyPaging() {
        return this.hierarchyPaging;
    }
    get getHierarchySize() {
        return this.size;
    }
    get getHierarchyDesc() {
        return this.desc;
    }
    get getHierarchySearchBy() {
        return this.searchBy;
    }
    get getHierarchyStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getMainCategoryId() {
        return this.mainCategoryId;
    }
    get getAssetCategoryId() {
        return this.assetCategoryId;
    }
    get getGroupId() {
        return this.groupId;
    }
    get getAssetProfilingClassId() {
        return this.assetProfillingClassId;
    }
    get getAssetProfilingId() {
        return this.assetProfillingId;
    }
    get getMainCategory() {
        return this.mainCategoryDesc;
    }
    get getAssetCategory() {
        return this.assetCategoryDesc;
    }
    get getGroup() {
        return this.groupDesc;
    }
    get getAssetProfilingClass() {
        return this.assetProfillingClassDesc;
    }
    get getAssetProfiling() {
        return this.assetProfillingDesc;
    }
    get getFilterHierarchyMainCategoryDesc() {
        return this.filterHierarchyMainCategory;
    }
    get getFilterHierarchyAssetCategoryDesc() {
        return this.filterHierarchyAssetCategory;
    }
    get getFilterHierarchyGroupDesc() {
        return this.filterHierarchyGroup;
    }
    get getFilterHierarchyAssetProfClassDesc() {
        return this.filterHierarchyAssetProfClass;
    }
    get getFilterHierarchyAssetProfDesc() {
        return this.filterHierarchyAssetProf;
    }
    get getHierarchyWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getHierarchyWasLoadQuickFilterMainCategory() {
        return this.wasLoadQuickFilterMainCategory;
    }
    get getHierarchyWasLoadQuickFilterAssetCategory() {
        return this.wasLoadQuickFilterAssetCategory;
    }
    get getHierarchyWasLoadQuickFilterGroup() {
        return this.wasLoadQuickFilterGroup;
    }
    get getHierarchyWasLoadQuickFilterAssetProfillingClass() {
        return this.wasLoadQuickFilterAssetProfillingClass;
    }
    get getHierarchyWasLoadQuickFilterAssetProfilling() {
        return this.wasLoadQuickFilterAssetProfilling;
    }
    get getdataFindHierarchyMainCategory() {
        return this.dataFindHierarchyMainCategory;
    }
    get getdataFindHierarchyAssetCategory() {
        return this.dataFindHierarchyAssetCategory;
    }
    get getdataFindHierarchyGroup() {
        return this.dataFindHierarchyGroup;
    }
    get getdataFindHierarchyAssetProfillingClass() {
        return this.dataFindHierarchyAssetProfillingClass;
    }
    get getdataFindHierarchyAssetProfilling() {
        return this.dataFindHierarchyAssetProfilling;
    }
    get getHierarchyMainCategoryDesc() {
        return this.dataFindHierarchyMainCategory;
    }
    get getHierarchyAssetCategoryDesc() {
        return this.dataFindHierarchyAssetCategory;
    }
    get getHierarchyGroupDesc() {
        return this.dataFindHierarchyGroup;
    }
    get getHierarchyAssetProfillingClassDesc() {
        return this.dataFindHierarchyAssetProfillingClass;
    }
    get getHierarchyAssetProfillingDesc() {
        return this.dataFindHierarchyAssetProfilling;
    }
    [_a = Mutations.SET_HIERARCHY_WAS_FIRST_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_HIERARCHY_RESET](payload) {
        this.resetHierarchy = payload;
    }
    [_c = Mutations.SET_HIERARCHY_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_d = Mutations.SET_HIERARCHY_LOADING](payload) {
        this.loading = payload;
    }
    [_e = Mutations.SET_HIERARCHY_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_f = Mutations.SET_HIERARCHY_LIST](payload) {
        this.hierarchyList = payload;
    }
    [_g = Mutations.SET_HIERARCHY_LIST_ID](payload) {
        this.hierarchyId = payload;
    }
    [_h = Mutations.SET_HIERARCHY_LIST_DESC](payload) {
        this.hierarchyDesc = payload;
    }
    [_j = Mutations.SET_HIERARCHY_PAGE](payload) {
        this.hierarchyPaging = payload;
    }
    [_k = Mutations.SET_HIERARCHY_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_l = Mutations.SET_HIERARCHY_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_m = Mutations.SET_HIERARCHY_SIZE](payload) {
        this.page = this.pageDefault;
        this.size = payload;
    }
    [_o = Mutations.SET_HIERARCHY_MAINCATEGORY_LIST_ID](payload) {
        this.mainCategoryId = payload;
    }
    [_p = Mutations.SET_HIERARCHY_ASSETCATEGORY_LIST_ID](payload) {
        this.assetCategoryId = payload;
    }
    [_q = Mutations.SET_HIERARCHY_GROUP_LIST_ID](payload) {
        this.groupId = payload;
    }
    [_r = Mutations.SET_HIERARCHY_ASSETPROFILINGCLASS_LIST_ID](payload) {
        this.assetProfillingClassId = payload;
    }
    [_s = Mutations.SET_HIERARCHY_ASSETPROFILING_LIST_ID](payload) {
        this.assetProfillingId = payload;
    }
    [_t = Mutations.SET_HIERARCHY_MAINCATEGORY_LIST_DESC](payload) {
        this.mainCategoryDesc = payload;
    }
    [_u = Mutations.SET_HIERARCHY_ASSETCATEGORY_LIST_DESC](payload) {
        this.assetCategoryDesc = payload;
    }
    [_v = Mutations.SET_HIERARCHY_GROUP_LIST_DESC](payload) {
        this.groupDesc = payload;
    }
    [_w = Mutations.SET_HIERARCHY_ASSETPROFILINGCLASS_LIST_DESC](payload) {
        this.assetProfillingClassDesc = payload;
    }
    [_x = Mutations.SET_HIERARCHY_ASSETPROFILING_LIST_DESC](payload) {
        this.assetProfillingDesc = payload;
    }
    [_y = Mutations.SET_SELECTED_HIERARCHYPROFILINGID](payload) {
        this.selectedHierarchyProfillingId = payload;
    }
    [_z = Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC](payload) {
        this.selectedHierarchyProfillingDesc = payload;
    }
    [_0 = Mutations.SET_SELECTED_HIERARCHYMAINCATDESC](payload) {
        this.selectedFilterMainCategoryDesc = payload;
    }
    [_1 = Mutations.SET_SELECTED_HIERARCHYASSETCATDESC](payload) {
        this.selectedFilterAssetCategoryDesc = payload;
    }
    [_2 = Mutations.SET_SELECTED_HIERARCHYGROUPDESC](payload) {
        this.selectedFilterGroupDesc = payload;
    }
    [_3 = Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC](payload) {
        this.selectedFilterAssetProfClassDesc = payload;
    }
    [_4 = Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC](payload) {
        this.selectedFilterAssetProfDesc = payload;
    }
    [_5 = Mutations.SET_SELECTED_HIERARCHY_STATUS](payload) {
        this.isActive = payload;
    }
    [_6 = Mutations.SET_FILTER_HIERARCHY_MAINCATEGORYDESC](payload) {
        this.filterHierarchyMainCategory = payload;
    }
    [_7 = Mutations.SET_FILTER_HIERARCHY_ASSETCATEGORYDESC](payload) {
        this.filterHierarchyAssetCategory = payload;
    }
    [_8 = Mutations.SET_FILTER_HIERARCHY_GROUPDESC](payload) {
        this.filterHierarchyGroup = payload;
    }
    [_9 = Mutations.SET_FILTER_HIERARCHY_ASSETPROFCLASSDESC](payload) {
        this.filterHierarchyAssetProfClass = payload;
    }
    [_10 = Mutations.SET_FILTER_HIERARCHY_ASSETPROFDESC](payload) {
        this.filterHierarchyAssetProf = payload;
    }
    [_11 = Mutations.SET_HIERARCHY_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_12 = Mutations.SET_HIERARCHY_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_13 = Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_14 = Mutations.SET_HIERARCHY_PAGE_FILTER_MAIN_CATEGORY](payload) {
        this.pageFilterMainCategory = payload;
    }
    [_15 = Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY](payload) {
        this.wasLoadQuickFilterMainCategory = payload;
    }
    [_16 = Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_CATEGORY](payload) {
        this.pageFilterAssetCategory = payload;
    }
    [_17 = Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY](payload) {
        this.wasLoadQuickFilterAssetCategory = payload;
    }
    [_18 = Mutations.SET_HIERARCHY_PAGE_FILTER_GROUP](payload) {
        this.pageFilterGroup = payload;
    }
    [_19 = Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP](payload) {
        this.wasLoadQuickFilterGroup = payload;
    }
    [_20 = Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING_CLASS](payload) {
        this.pageFilterAssetProfillingClass = payload;
    }
    [_21 = Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS](payload) {
        this.wasLoadQuickFilterAssetProfillingClass = payload;
    }
    [_22 = Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING](payload) {
        this.pageFilterAssetProfilling = payload;
    }
    [_23 = Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING](payload) {
        this.wasLoadQuickFilterAssetProfilling = payload;
    }
    [_24 = Mutations.SET_FIND_HIERARCHY_MAIN_CATEGORY](payload) {
        this.dataFindHierarchyMainCategory = payload;
    }
    [_25 = Mutations.SET_FIND_HIERARCHY_ASSET_CATEGORY](payload) {
        this.dataFindHierarchyAssetCategory = payload;
    }
    [_26 = Mutations.SET_FIND_HIERARCHY_GROUP](payload) {
        this.dataFindHierarchyGroup = payload;
    }
    [_27 = Mutations.SET_FIND_HIERARCHY_ASSET_PROFILLING_CLASS](payload) {
        this.dataFindHierarchyAssetProfillingClass = payload;
    }
    [_28 = Mutations.SET_FIND_HIERARCHY_ASSET_PROFILLING](payload) {
        this.dataFindHierarchyAssetProfilling = payload;
    }
    [_29 = Mutations.SET_HIERARCHY_SELECTED_DESC](payload) {
        this.desc = payload;
    }
    [_30 = Mutations.SET_HIERARCHY_SELECTED_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_31 = Mutations.SET_HIERARCHY_MAIN_CATEGORY_SELECTED_DESC](payload) {
        this.descFilterMainCategory = payload;
    }
    [_32 = Mutations.SET_HIERARCHY_MAIN_CATEGORY_SELECTED_SEARCH_BY](payload) {
        this.searchByFilterMainCategory = payload;
    }
    [_33 = Mutations.SET_HIERARCHY_ASSET_CATEGORY_SELECTED_DESC](payload) {
        this.descFilterAssetCategory = payload;
    }
    [_34 = Mutations.SET_HIERARCHY_ASSET_CATEGORY_SELECTED_SEARCH_BY](payload) {
        this.searchByFilterAssetCategory = payload;
    }
    [_35 = Mutations.SET_HIERARCHY_GROUP_SELECTED_DESC](payload) {
        this.descFilterGroup = payload;
    }
    [_36 = Mutations.SET_HIERARCHY_GROUP_SELECTED_SEARCH_BY](payload) {
        this.searchByFilterGroup = payload;
    }
    [_37 = Mutations.SET_HIERARCHY_ASSET_PROFILLING_CLASS_SELECTED_DESC](payload) {
        this.descFilterAssetProfillingClass = payload;
    }
    [_38 = Mutations.SET_HIERARCHY_ASSET_PROFILLING_CLASS_SELECTED_SEARCH_BY](payload) {
        this.searchByFilterAssetProfillingClass = payload;
    }
    [_39 = Mutations.SET_HIERARCHY_ASSET_PROFILLING_SELECTED_DESC](payload) {
        this.descFilterAssetProfilling = payload;
    }
    [_40 = Mutations.SET_HIERARCHY_ASSET_PROFILLING_SELECTED_SEARCH_BY](payload) {
        this.searchByFilterAssetProfilling = payload;
    }
    [_41 = Actions.GET_HIERARCHY_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                IsActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_HIERARCHY_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_HIERARCHY_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_HIERARCHY_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_HIERARCHY_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_42 = Actions.GET_HIERARCHY_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc.toString(),
                SearchBy: this.searchBy.toString(),
                HierarchyProfillingId: this.selectedHierarchyProfillingId,
                HierarchyProfillingDesc: this.selectedHierarchyProfillingDesc,
                IsActive: this.isActive,
                MainCategoryDesc: this.selectedFilterMainCategoryDesc,
                AssetCategoryDesc: this.selectedFilterAssetCategoryDesc,
                GroupDesc: this.selectedFilterGroupDesc,
                AssetProfillingClassDesc: this.selectedFilterAssetProfClassDesc,
                AssetProfillingDesc: this.selectedFilterAssetProfDesc
            };
            const dataId = [...this.hierarchyId];
            const dataDesc = [...this.hierarchyDesc];
            const dataMainDesc = [...this.filterHierarchyMainCategory];
            const dataAssetDesc = [...this.filterHierarchyAssetCategory];
            const dataGroupDesc = [...this.filterHierarchyGroup];
            const dataAssetProfClassDesc = [...this.filterHierarchyAssetProfClass];
            const dataAssetProfDesc = [...this.filterHierarchyAssetProf];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataId.push({
                                    value: data.hierarchyProfillingId,
                                    label: data.hierarchyProfillingId
                                });
                                dataDesc.push({
                                    value: data.hierarchyProfillingDesc,
                                    label: data.hierarchyProfillingDesc
                                });
                                dataMainDesc.push({
                                    value: data.mainCategoryDesc,
                                    label: data.mainCategoryDesc
                                });
                                dataAssetDesc.push({
                                    value: data.assetCategoryDesc,
                                    label: data.assetCategoryDesc
                                });
                                dataGroupDesc.push({
                                    value: data.groupDesc,
                                    label: data.groupDesc
                                });
                                dataAssetProfClassDesc.push({
                                    value: data.assetProfillingClassDesc,
                                    label: data.assetProfillingClassDesc
                                });
                                dataAssetProfDesc.push({
                                    value: data.assetProfillingDesc,
                                    label: data.assetProfillingDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER, false);
                        }
                        // eslint-disable-next-line arrow-body-style
                        const distinctMainCatDesc = Array.from(new Set(dataMainDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataMainDesc.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetCatDesc = Array.from(new Set(dataAssetDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetDesc.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctGroup = Array.from(new Set(dataGroupDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataGroupDesc.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetProfClass = Array.from(new Set(dataAssetProfClassDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetProfClassDesc.find((s) => s.label === label)
                                    .label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetProf = Array.from(new Set(dataAssetProfDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetProfDesc.find((s) => s.label === label).label
                            };
                        });
                        this.context.commit(Mutations.SET_HIERARCHY_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_HIERARCHY_LIST_DESC, dataDesc);
                        this.context.commit(Mutations.SET_FILTER_HIERARCHY_MAINCATEGORYDESC, distinctMainCatDesc);
                        this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETCATEGORYDESC, distinctAssetCatDesc);
                        this.context.commit(Mutations.SET_FILTER_HIERARCHY_GROUPDESC, distinctGroup);
                        this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFCLASSDESC, distinctAssetProfClass);
                        this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFDESC, distinctAssetProf);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_43 = Actions.CREATE_HIERARCHY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_HIERARCHY_LIST_ID, []);
                        this.context.commit(Mutations.SET_HIERARCHY_LIST_DESC, []);
                        this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
                        this.context.commit(Mutations.SET_HIERARCHY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.RESET_HIERARCHY_FILTER);
                        this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_44 = Actions.UPDATE_HIERARCHY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_HIERARCHY_LIST_ID, []);
                        this.context.commit(Mutations.SET_HIERARCHY_LIST_DESC, []);
                        this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
                        this.context.commit(Mutations.SET_HIERARCHY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.RESET_HIERARCHY_FILTER);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_45 = Actions.GET_HIERARCHY_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                HierarchyProfillingId: data.hierarchyProfillingId,
                HierarchyProfillingDesc: data.hierarchyProfillingDesc,
                IsActive: data.isActive,
                MainCategoryDesc: data.mainCategoryDesc,
                AssetCategoryDesc: data.assetCategoryDesc,
                GroupDesc: data.groupDesc,
                AssetProfillingClassDesc: data.assetProfillingClassDesc,
                AssetProfillingDesc: data.assetProfillingDesc
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _77, _78;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_HIERARCHY_LIST, ((_77 = res.data.result.content) === null || _77 === void 0 ? void 0 : _77.data) || []);
                        this.context.commit(Mutations.SET_HIERARCHY_PAGE, ((_78 = res.data.result.content) === null || _78 === void 0 ? void 0 : _78.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, data.isActive);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, data.hierarchyProfillingId);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, data.hierarchyProfillingDesc);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYMAINCATDESC, data.mainCategoryDesc);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETCATDESC, data.assetCategoryDesc);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYGROUPDESC, data.groupDesc);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC, data.assetProfillingClassDesc);
                        this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC, data.assetProfillingDesc);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_HIERARCHY_LOAD_PAGE, true);
                        }
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_46 = Actions.GET_HIERARCHY_MAINCAT_LIST_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterMainCategory.toString(),
                Size: '10',
                Desc: this.descFilterMainCategory,
                SearchBy: this.searchByFilterMainCategory,
                mainCategoryId: [],
                mainCategoryDesc: [],
                isActive: true
            };
            const dataId = [...this.mainCategoryId];
            const dataDesc = [...this.mainCategoryDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages ===
                                this.pageFilterMainCategory) {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataId.push({
                                    value: data.mainCategoryId,
                                    label: data.mainCategoryDesc
                                });
                                dataDesc.push({
                                    value: data.mainCategoryDesc,
                                    label: data.mainCategoryDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY, false);
                        }
                        this.context.commit(Mutations.SET_HIERARCHY_MAINCATEGORY_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_HIERARCHY_MAINCATEGORY_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_MAIN_CATEGORY, true);
                    reject(false);
                });
            });
        });
    }
    [_47 = Actions.GET_HIERARCHY_ASSETCATEGORY_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetcategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterAssetCategory.toString(),
                Size: '10',
                Desc: this.descFilterAssetCategory,
                SearchBy: this.searchByFilterAssetCategory,
                assetCategoryId: [],
                assetCategoryDesc: [],
                isActive: true
            };
            const dataId = [...this.assetCategoryId];
            const dataDesc = [...this.assetCategoryDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages ===
                                this.pageFilterAssetCategory) {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataId.push({
                                    value: data.assetCategoryId,
                                    label: data.assetCategoryDesc
                                });
                                dataDesc.push({
                                    value: data.assetCategoryDesc,
                                    label: data.assetCategoryDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY, false);
                        }
                        this.context.commit(Mutations.SET_HIERARCHY_ASSETCATEGORY_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_HIERARCHY_ASSETCATEGORY_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_CATEGORY, true);
                    reject(false);
                });
            });
        });
    }
    [_48 = Actions.GET_HIERARCHY_GROUP_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/group/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterGroup.toString(),
                Size: '10',
                Desc: this.descFilterGroup,
                SearchBy: this.searchByFilterGroup,
                groupId: [],
                groupDesc: [],
                isActive: true
            };
            const dataId = [...this.groupId];
            const dataDesc = [...this.groupDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages ===
                                this.pageFilterGroup) {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataId.push({
                                    value: data.groupId,
                                    label: data.groupDesc
                                });
                                dataDesc.push({
                                    value: data.groupDesc,
                                    label: data.groupDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP, false);
                        }
                        this.context.commit(Mutations.SET_HIERARCHY_GROUP_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_HIERARCHY_GROUP_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_GROUP, true);
                    reject(false);
                });
            });
        });
    }
    [_49 = Actions.GET_HIERARCHY_ASSETPROFILINGCLASS_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterAssetProfillingClass.toString(),
                Size: '10',
                Desc: this.descFilterAssetProfillingClass,
                SearchBy: this.searchByFilterAssetProfillingClass,
                assetProfillingClassId: [],
                assetProfillingClassDesc: [],
                isActive: true
            };
            const dataId = [...this.assetProfillingClassId];
            const dataDesc = [...this.assetProfillingClassDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages ===
                                this.pageFilterAssetProfillingClass) {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataId.push({
                                    value: data.assetProfillingClassId,
                                    label: data.assetProfillingClassDesc
                                });
                                dataDesc.push({
                                    value: data.assetProfillingClassDesc,
                                    label: data.assetProfillingClassDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS, false);
                        }
                        this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILINGCLASS_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILINGCLASS_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING_CLASS, true);
                    reject(false);
                });
            });
        });
    }
    [_50 = Actions.GET_HIERARCHY_ASSETPROFILING_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterAssetProfilling.toString(),
                Size: '10',
                Desc: this.descFilterAssetProfilling,
                SearchBy: this.searchByFilterAssetProfilling,
                assetProfillingId: [],
                assetProfillingDesc: [],
                isActive: true
            };
            const dataId = [...this.assetProfillingId];
            const dataDesc = [...this.assetProfillingDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages ===
                                this.pageFilterAssetProfilling) {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataId.push({
                                    value: data.assetProfillingId,
                                    label: data.assetProfillingDesc
                                });
                                dataDesc.push({
                                    value: data.assetProfillingDesc,
                                    label: data.assetProfillingDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING, false);
                        }
                        this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILING_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILING_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_HIERARCHY_WAS_LOAD_QUICK_FILTER_ASSET_PROFILLING, false);
                    reject(false);
                });
            });
        });
    }
    [_51 = Actions.DOWNLOAD_HIERARCHY]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/hierarchyprofilling/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    hierarchyProfillingId: this.selectedHierarchyProfillingId,
                    hierarchyProfillingDesc: this.selectedHierarchyProfillingDesc,
                    isActive: this.isActive,
                    mainCategoryDesc: this.selectedFilterMainCategoryDesc,
                    assetCategoryDesc: this.selectedFilterAssetCategoryDesc,
                    groupDesc: this.selectedFilterGroupDesc,
                    assetProfillingClassDesc: this.selectedFilterAssetProfClassDesc,
                    assetProfillingDesc: this.selectedFilterAssetProfDesc
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_52 = Actions.UPDATE_HIERARCHY_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, this.pageFilter);
        });
    }
    [_53 = Actions.UPDATE_HIERARCHY_PAGE_FILTER_MAIN_CATEGORY]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_MAIN_CATEGORY, this.pageFilterMainCategory + 1);
        });
    }
    [_54 = Actions.UPDATE_HIERARCHY_PAGE_FILTER_ASSET_CATEGORY]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_CATEGORY, this.pageFilterAssetCategory + 1);
        });
    }
    [_55 = Actions.UPDATE_HIERARCHY_PAGE_FILTER_GROUP]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_GROUP, this.pageFilterGroup + 1);
        });
    }
    [_56 = Actions.UPDATE_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING_CLASS]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING_CLASS, this.pageFilterAssetProfillingClass + 1);
        });
    }
    [_57 = Actions.UPDATE_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING, this.pageFilterAssetProfilling + 1);
        });
    }
    [_58 = Actions.GET_HIERARCHY_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_HIERARCHY_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_HIERARCHY_LIST_FILTER, {
                    hierarchyProfillingId: this.selectedHierarchyProfillingId,
                    hierarchyProfillingDesc: this.selectedHierarchyProfillingDesc,
                    isActive: this.isActive,
                    mainCategoryDesc: this.selectedFilterMainCategoryDesc,
                    assetCategoryDesc: this.selectedFilterAssetCategoryDesc,
                    groupDesc: this.selectedFilterGroupDesc,
                    assetProfillingClassDesc: this.selectedFilterAssetProfClassDesc,
                    assetProfillingDesc: this.selectedFilterAssetProfDesc
                });
            }
        });
    }
    [_59 = Actions.UPDATE_SELECTED_HPROFDESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, data);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, this.isActive);
            this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYMAINCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYGROUPDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_DATA);
        });
    }
    [_60 = Actions.UPDATE_SELECTED_HPROFID](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, this.isActive);
            this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_MAINCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_GROUPDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, data);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYMAINCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYGROUPDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_DATA);
            // this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
        });
    }
    [_61 = Actions.UPDATE_SELECTED_HIERARCHY_STATUS](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, data);
            this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_MAINCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_GROUPDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYMAINCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYGROUPDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_DATA);
            this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
        });
    }
    [_62 = Actions.UPDATE_SELECTED_HIERARCHY_FILTER_STATUS](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, data);
            this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_MAINCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_GROUPDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYMAINCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYGROUPDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_DATA);
        });
    }
    [_63 = Actions.RESET_HIERARCHY_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_HIERARCHY_USE_FILTER, true);
            this.context.commit(Mutations.SET_HIERARCHY_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_LIST_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, true);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_MAINCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETCATEGORYDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_GROUPDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_FILTER_HIERARCHY_ASSETPROFDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYMAINCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETCATDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYGROUPDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFCLASSDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYASSETPROFDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_DATA);
            this.context.commit(Mutations.SET_HIERARCHY_RESET, true);
            this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
            this.context.dispatch(Actions.UPDATE_HIERARCHY_MAIN_CATEGORY_DESC, '');
            this.context.dispatch(Actions.UPDATE_HIERARCHY_ASSET_CATEGORY_DESC, '');
            this.context.dispatch(Actions.UPDATE_HIERARCHY_GROUP_DESC, '');
            this.context.dispatch(Actions.UPDATE_HIERARCHY_ASSET_PROFILLING_CLASS_DESC, '');
            this.context.dispatch(Actions.UPDATE_HIERARCHY_ASSET_PROFILLING_DESC, '');
        });
    }
    [_64 = Actions.UPDATE_HIERARCHY_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_SIZE, data);
            this.context.commit(Mutations.SET_HIERARCHY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_HIERARCHY_DATA);
        });
    }
    [_65 = Actions.FIND_HIERARCHY_MAIN_CATEGORY](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '10',
                mainCategoryId: [],
                mainCategoryDesc: [data],
                isActive: null
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_FIND_HIERARCHY_MAIN_CATEGORY, res.data.result.content.data[0].mainCategoryId);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_66 = Actions.FIND_HIERARCHY_ASSET_CATEGORY](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetcategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '10',
                assetCategoryId: [],
                assetCategoryDesc: [data],
                isActive: null
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_FIND_HIERARCHY_ASSET_CATEGORY, res.data.result.content.data[0].assetCategoryId);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_67 = Actions.FIND_HIERARCHY_GROUP](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/group/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '10',
                Desc: '',
                SearchBy: '',
                groupId: [],
                groupDesc: [data],
                isActive: null
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_FIND_HIERARCHY_GROUP, res.data.result.content.data[0].groupId);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_68 = Actions.FIND_HIERARCHY_ASSET_PROFILLING_CLASS](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1',
                Page: '1',
                Size: '10'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: 1,
                Size: '10',
                Desc: '',
                SearchBy: '',
                assetProfillingClassId: [],
                assetProfillingClassDesc: [data],
                isActive: null
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_FIND_HIERARCHY_ASSET_PROFILLING_CLASS, res.data.result.content.data[0].assetProfillingClassId);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_69 = Actions.FIND_HIERARCHY_ASSET_PROFILLING](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '10',
                assetProfillingId: [],
                assetProfillingDesc: [data],
                isActive: null
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_FIND_HIERARCHY_ASSET_PROFILLING, res.data.result.content.data[0].assetProfillingId);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_70 = Actions.UPDATE_HIERARCHY_DESC_STRING](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_SELECTED_SEARCH_BY, 'HierarchyProfillingDesc');
            this.context.commit(Mutations.SET_HIERARCHY_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_HIERARCHY_USE_FILTER, true);
            this.context.commit(Mutations.SET_HIERARCHY_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_LIST_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
            this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
        });
    }
    [_71 = Actions.UPDATE_HIERARCHY_DESC_INT](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_SELECTED_SEARCH_BY, 'HierarchyProfillingId');
            this.context.commit(Mutations.SET_HIERARCHY_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_HIERARCHY_USE_FILTER, true);
            this.context.commit(Mutations.SET_HIERARCHY_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_LIST_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGID, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHYPROFILINGDESC, []);
            this.context.commit(Mutations.SET_SELECTED_HIERARCHY_STATUS, true);
            this.context.dispatch(Actions.GET_HIERARCHY_LIST_ID_DESC);
        });
    }
    [_72 = Actions.UPDATE_HIERARCHY_MAIN_CATEGORY_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_MAIN_CATEGORY, 1);
            this.context.commit(Mutations.SET_HIERARCHY_MAINCATEGORY_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_MAINCATEGORY_LIST_DESC, []);
            this.context.commit(Mutations.SET_HIERARCHY_MAIN_CATEGORY_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_MAIN_CATEGORY_SELECTED_SEARCH_BY, 'MainCategoryDesc');
            this.context.dispatch(Actions.GET_HIERARCHY_MAINCAT_LIST_DATA);
        });
    }
    [_73 = Actions.UPDATE_HIERARCHY_ASSET_CATEGORY_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_CATEGORY, 1);
            this.context.commit(Mutations.SET_HIERARCHY_ASSETCATEGORY_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_ASSETCATEGORY_LIST_DESC, []);
            this.context.commit(Mutations.SET_HIERARCHY_ASSET_CATEGORY_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_ASSET_CATEGORY_SELECTED_SEARCH_BY, 'AssetCategoryDesc');
            this.context.dispatch(Actions.GET_HIERARCHY_ASSETCATEGORY_LIST_ID_DESC);
        });
    }
    [_74 = Actions.UPDATE_HIERARCHY_GROUP_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_GROUP, 1);
            this.context.commit(Mutations.SET_HIERARCHY_GROUP_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_GROUP_LIST_DESC, []);
            this.context.commit(Mutations.SET_HIERARCHY_GROUP_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_GROUP_SELECTED_SEARCH_BY, 'GroupDesc');
            this.context.dispatch(Actions.GET_HIERARCHY_GROUP_LIST_ID_DESC);
        });
    }
    [_75 = Actions.UPDATE_HIERARCHY_ASSET_PROFILLING_CLASS_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING_CLASS, 1);
            this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILINGCLASS_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILINGCLASS_LIST_DESC, []);
            this.context.commit(Mutations.SET_HIERARCHY_ASSET_PROFILLING_CLASS_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_ASSET_PROFILLING_CLASS_SELECTED_SEARCH_BY, 'AssetProfillingClassDesc');
            this.context.dispatch(Actions.GET_HIERARCHY_ASSETPROFILINGCLASS_LIST_ID_DESC);
        });
    }
    [_76 = Actions.UPDATE_HIERARCHY_ASSET_PROFILLING_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_HIERARCHY_PAGE_FILTER_ASSET_PROFILLING, 1);
            this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILING_LIST_ID, []);
            this.context.commit(Mutations.SET_HIERARCHY_ASSETPROFILING_LIST_DESC, []);
            this.context.commit(Mutations.SET_HIERARCHY_ASSET_PROFILLING_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_HIERARCHY_ASSET_PROFILLING_SELECTED_SEARCH_BY, 'AssetProfillingDesc');
            this.context.dispatch(Actions.GET_HIERARCHY_ASSETPROFILING_LIST_ID_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _t, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _u, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _v, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _w, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _x, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _y, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _z, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _0, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _1, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _2, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _3, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _4, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _5, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _6, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _7, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _8, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _9, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _10, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _11, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _12, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _13, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _14, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _15, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _16, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _17, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _18, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _19, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _20, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _21, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _22, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _23, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _24, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _25, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _26, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _27, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _28, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _29, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _30, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _31, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _32, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _33, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _34, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _35, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _36, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _37, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _38, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _39, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _40, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _41, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _42, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _43, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _44, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _45, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _46, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _47, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _48, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _49, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _50, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _51, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _52, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _53, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _54, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _55, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _56, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _57, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _58, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _59, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _60, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _61, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _62, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _63, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _64, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _65, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _66, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _67, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _68, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _69, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _70, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _71, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _72, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _73, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _74, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _75, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _76, null);
HierarchyModule = __decorate([
    Module
], HierarchyModule);
export default HierarchyModule;
